import { createFractionsFromIds } from './createFractionsFromIds';

export const createDisabledFractionsForIds = (ids: number[]) => createFractionsFromIds(ids, 0.0);
